import React, {createRef, useState} from 'react';
import ScanditBarcodeScanner from 'scandit-sdk-react';
import PropTypes from 'prop-types';
import {
  Barcode,
  BarcodePicker,
  Camera,
  ScanSettings,
  SingleImageModeSettings,
} from 'scandit-sdk';
/* eslint-disable react/prop-types */
const BarcodeScanner = ({onScan, canScan}) => {
  const _barcodeRef = createRef();
  const getScanSettings = () => {
    return new ScanSettings({
      enabledSymbologies: [
        Barcode.Symbology.CODABAR,
        Barcode.Symbology.CODE11,
        Barcode.Symbology.CODE128,
        Barcode.Symbology.CODE25,
        Barcode.Symbology.CODE32,
        Barcode.Symbology.CODE39,
        Barcode.Symbology.CODE93,
        Barcode.Symbology.EAN13,
        Barcode.Symbology.EAN8,
        Barcode.Symbology.UPCE,
        Barcode.Symbology.UPCA,
        Barcode.Symbology.MICRO_QR,
        Barcode.Symbology.QR,
      ],
      codeDuplicateFilter: 3000,
    });
  };
  const getSingleImageModeSettings = () => {
    return {
      desktop: {
        usageStrategy: SingleImageModeSettings.UsageStrategy.FALLBACK,
        mobile: {
          usageStrategy: SingleImageModeSettings.UsageStrategy.FALLBACK,
        },
      },
    };
  };

  const licenseKey =
    'AW8Ax7WBIUq9Iw1UIB00oBUX9ZvdPrwDmkiVFCxy4dhaLhyA31tPFx0FRY3dRTuYwXpSNlMzrDbgIKkyEnkPef4QGGC/K31HRHf7F+Rm0WvOcSnR0WlB7aBHBTmBVJhFVXRm6z5iXoorNlsFCCZ4tHgC+DaRMREFRkPBA7rOSyMIEvHPKp35HnwK097T4bkfnCZIROdDHl1a/gFk6xUvTm/4i5ytu/7GpkJ5V35JcJMJh9vnfNlHqLolfHPVySCKbqOtBSmBsyKdisM28XvFJhiC99vCMQCie6U7ux2Wj4IShWEGBlYVIeMHvh3Wt1b6c62MSvjpemkXNXJJJjjRdweuRLjyQ6a+lT1vIGKtDoTEPIlQA+ROg5hBFEfc+MeyGDxxPUc7CEURYtVRgwGR8Hqt8cajkMHq0l3gwezfjLoutepuBrxhvwgFEYbvIs2AZ5Ipz6UMCGJ5JYEayt1sC2wVuRRGdwwC6UlZm2LX/8tY/JTvBQgMO8iSDjFgYHvpd2BAf2/MSEQZ+P4XGtxqlqyOsCtDwWPd14nRlIM8VjSkBGD7F2AgnVaJECcfohWX7rPoPj3wYs3vFch4A2ilwoWqTwvFon/Rqr1HXx6dOZxfV1rkF08z2KkwRCXzTRUtaevHjQo0OmtWcsL84+mW67tcynqWCBB+Mmoy3BGpGCaLU+Y3ib5Sv03TSDed9xWZJj/3xwZ6X89Y6hT+37Ef2Ubgk6pQd1NjPBKWLtgyk4/Sra0mIY20Pjs47mGw/QWUsB5mhXDEml4pBpsCmMmOeAjznFG2UxzTqgHmQyTmBW1Yr6qtLSbwgw8jbKcdLZE7YeE1jGSvMQ==';

  const [isScanned, setIsScanned] = useState(false);
  const handleScan = data => {
    if (!canScan) {
      console.log('One scanning is on progress.. ignoring this scann...');
      return;
    }
    if (data.barcodes && data.barcodes.length) {
      setIsScanned(true);
      onScan(data.barcodes[0].data);
    }
  };

  const [showFullView, setShowFullView] = useState(false);

  // useEffect(() => {

  //   const _scanCont = document.querySelector('.scandit-container');
  //   console.log(_scanCont);
  //   if (_scanCont) {
  //     console.log('_scanCont');
  //     _scanCont.parentElement.classList.add("h-full w-full");
  //   }
  // }, []);

  console.log(`can scan: ${canScan}`);
  return (
    <div>
      <ScanditBarcodeScanner
        ref={_barcodeRef}
        licenseKey={licenseKey}
        engineLocation="https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build"
        preloadBlurryRecognition={true}
        preloadEngine={true}
        onReady={() => {
          console.log('ready..');
        }}
        onScan={data => {
          if (isScanned === false) {
            handleScan(data);
          }
        }}
        onScanError={console.log}
        scanSettings={getScanSettings()}
        paused={canScan === true ? false : true}
        accessCamera={true}
        camera={undefined}
        cameraSettings={undefined}
        enableCameraSwitcher={true}
        enablePinchToZoom={true}
        enableTapToFocus={true}
        enableTorchToggle={true}
        guiStyle={BarcodePicker.GuiStyle.LASER}
        laserArea={{x: 0, y: 0, width: 1, height: 1}}
        playSoundOnScan={true}
        targetScanningFPS={30}
        vibrateOnScan={true}
        videoFit={BarcodePicker.ObjectFit.COVER}
        visible={true}
        viewfinderArea={{x: 0, y: 0, width: 1, height: 1}}
        zoom={0}
        // only set on component creation, can not be changed afterwards
        cameraType={Camera.Type.BACK}
        singleImageModeSettings={getSingleImageModeSettings()}
      />
    </div>
  );
};

BarcodeScanner.proptypes = {
  onScan: PropTypes.func,
};
export default BarcodeScanner;
